import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import ProfileView from "./ProfileView";
import SendMessageModal from "./SendMessageModal";

export default function ProfileModal({ open, onClose, user, affiliateId, affiliateEmail, onUserUpdated }) {
    const navigate = useNavigate();
    const role = localStorage.getItem("role");

    // State for SendMessageModal
    const [sendMessageOpen, setSendMessageOpen] = useState(false);

    const handleViewFullProfile = () => {
        // Close the modal first
        onClose();

        // Navigate to Members page with user data
        navigate("/members", {
            state: {
                selectedUser: {
                    ...user,
                    userId: user.id || user.userId,
                    id: user.id || user.userId
                },
                affiliateId: affiliateId
            }
        });
    };

    // Handle send message
    const handleSendMessage = (selectedUser) => {
        setSendMessageOpen(true);
    };

    if (!user) return null;

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="sm"
                fullWidth
                fullScreen={window.innerWidth < 600}
                slotProps={{ root: { sx: { zIndex: 2100 } } }}
            >
                <DialogTitle>{user.fullName}'s Profile</DialogTitle>
                <DialogContent sx={{ p: 0, m: 0 }}>
                    <ProfileView
                        user={user}
                        onSendMessage={handleSendMessage}
                        onUserUpdated={onUserUpdated}
                        nestedDialogZIndex={2200}
                    />
                </DialogContent>
                <DialogActions>
                    {(role === "affiliate" || role === "trainer") && (
                        <Button
                            onClick={handleViewFullProfile}
                            color="primary"
                            variant="contained"
                        >
                            View Full Profile
                        </Button>
                    )}
                    <Button onClick={onClose} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* SendMessageModal */}
            <SendMessageModal
                open={sendMessageOpen}
                onClose={() => setSendMessageOpen(false)}
                affiliate={affiliateId}
                affiliateEmail={affiliateEmail}
                preSelectedUsers={[user]}
            />
        </>
    );
}